import { createSelector } from 'reselect';
import { serviceProviderAdditionalFields } from 'selectors/serviceProviderSelectors.js';

const stableObject = {};
const stableArray = [];

export const defaultFolders = [
  {
    id: 'inbox',
    svg: 'Inbox',
    name: 'Inbox',
    nonLeads: true,
    statusIds: ['1'],
    visibility: ['nav', 'notificationsSlider'],
  },
  {
    id: 'conversations',
    svg: 'Conversations',
    name: 'Conversations',
    leads: true,
    visibility: ['nav', 'notificationsSlider'],
  },
  {
    id: 'others',
    svg: 'Archive',
    name: 'Other',
    nonLeads: true,
    statusIds: ['3', '4'],
    visibility: ['notificationsSlider'],
  },
];

export const inboxFoldersSelector = createSelector(serviceProviderAdditionalFields, (fields) => {
  return ((fields || stableObject).inbox || stableObject).folders || defaultFolders;
});

export default inboxFoldersSelector;
